<span [class]="pillClass()">{{ labelKey() | translate }}</span>
